import { call, put, takeEvery } from 'redux-saga/effects';
import { api } from 'services/api';
import { PayloadAction } from '@reduxjs/toolkit';
import { notificationContainer } from 'utils/notificationContainer';
import {
	getSmsListRequest,
	getSmsListSuccess,
	getSmsListFailure,
	getSmsTypesRequest,
	getSmsTypesSuccess,
	getSmsTypesFailure,
	sendSmsRequest,
	sendSmsSuccess,
	sendSmsFailure,
} from './reducer';
import {
	TSmsListRequest,
	TSmsListResponsePayload,
	TSmsTypesResponsePayload,
	TSmsSendRequest,
} from './types';
import axios from 'axios';

function* getSmsListRequestWorker({ payload }: PayloadAction<TSmsListRequest>) {
	try {
		const response: TSmsListResponsePayload = yield call(api.sms.getSmsList, payload);
		yield put(getSmsListSuccess(response));
	} catch (error) {
		yield put(getSmsListFailure());
		notificationContainer(
			error instanceof Error ? error.message : 'Failed to load SMS list',
			'error',
		);
	}
}

function* getSmsTypesRequestWorker() {
	try {
		const response: TSmsTypesResponsePayload = yield call(api.sms.getSmsTypes);
		yield put(getSmsTypesSuccess(response));
	} catch (error) {
		yield put(getSmsTypesFailure());
		if (axios.isAxiosError(error)) {
			notificationContainer(
				String(error?.response?.data?.message ?? error.message ?? 'Error!'),
				'error',
			);
		}
	}
}

function* sendSmsRequestWorker({ payload }: PayloadAction<TSmsSendRequest>) {
	try {
		yield call(api.sms.sendSms, payload);
		yield put(sendSmsSuccess());
		notificationContainer('SMS has been sent successfully', 'success');
	} catch (error) {
		yield put(sendSmsFailure());
		if (axios.isAxiosError(error)) {
			notificationContainer(String(error.response?.data?.message ?? 'Error'), 'error');
		}
	}
}

export function* smsSaga() {
	yield takeEvery(getSmsListRequest.type, getSmsListRequestWorker);
	yield takeEvery(getSmsTypesRequest.type, getSmsTypesRequestWorker);
	yield takeEvery(sendSmsRequest.type, sendSmsRequestWorker);
}
